import React, { useState } from 'react';
import BaseModal from '../../general/BaseModal';
import { translate as t } from '../../../lib/I18n';
import SmartcardAppIcons from '../delivery/smartcard/SmartcardAppIcons';
import PropTypes from 'prop-types';
import FormattedHTMLMessage from '../../general/FormattedHTMLMessage';
import STicketLoadingDetails from '../delivery/sticket/STicketLoadingDetails';

function DeliveryInformationSTicket({ brand }) {
    const [showAppModal, setShowAppModal] = useState(false);

    const toggleAppModal = () => setShowAppModal(!showAppModal);

    const renderModal = () => (<BaseModal
        titleText={t('booking.delivery.sticket.modal.title')}
        className="modal--lg load-smartcard-modal"
        onClose={toggleAppModal}
        hideContinue
    >
        <STicketLoadingDetails />
    </BaseModal>);

    return (
        <React.Fragment>
            <div className="order-summary__load-smartcard-info">
                <h3 className="text-weight--bold margin-bottom--xs">
                    {t('confirmation.sTicket.app.title')}
                </h3>
                <p className="text-size--normal leading-md">
                    <FormattedHTMLMessage message={t('confirmation.sTicket.app.description', {
                         brand
                    })} />{' '}
                    <SmartcardAppIcons toggleAppModal={toggleAppModal} />
                </p>
            </div>
            {showAppModal && renderModal()}
        </React.Fragment>
    );
}

DeliveryInformationSTicket.propTypes = {
  brand: PropTypes.string.isRequired,
};

export default DeliveryInformationSTicket;
